// Login state helpers for the router guard and the Login page.
// Roles come from the login's custom claims (kept in sync with users.role by the syncUserClaims function).
import { auth } from '@/firebase'
import { onAuthStateChanged } from 'firebase/auth'

export { STAFF_ROLES, homeFor, safeRedirect, requiresLogin, decideAccess } from './accessRules'

// Resolves once Firebase has restored the session on page load (or found none),
// so a refresh doesn't look like "signed out" for a moment.
let authReady = null
export function waitForAuth() {
  if (!authReady) {
    authReady = new Promise(resolve => {
      const unsubscribe = onAuthStateChanged(auth, user => {
        unsubscribe()
        resolve(user)
      })
    })
  }
  return authReady
}

// { role, access } from the current login's claims, or null when signed out
export async function currentClaims() {
  await waitForAuth()
  const user = auth.currentUser
  if (!user) return null
  const { claims } = await user.getIdTokenResult()
  return { role: claims.role || null, access: claims.access || null }
}
